import { GlobalStatus } from "@gtpl/shared-models/common-models";
import { SaleOrderDto } from "@gtpl/shared-models/sale-management";
import { ApiProperty } from "@nestjs/swagger";
import { SaleOrder } from "libs/shared-models/sale-management/src/lib/sale-order/dto/so-details.dto";

export class SoInspectionDTO{

    @ApiProperty()
    soInspectionId: number;
    @ApiProperty()
    inspectionName: string;
    @ApiProperty()
    isChecked: GlobalStatus;
    @ApiProperty()
    isActive: boolean;
    @ApiProperty()
    createdAt: Date;
    @ApiProperty()
    createdUser: string | null;
    @ApiProperty()
    updatedAt: Date;
    @ApiProperty()
    updatedUser: string | null;
    @ApiProperty()
    versionFlag: number;
    @ApiProperty()
    saleOrderInfo: SaleOrder;
    @ApiProperty()
    saleOrderId: number;
    @ApiProperty()
    saleOrderNumber: string;
    
    
}